import React from "react";
import { Header } from "@amzn/awsui-components-react";
import PropTypes from "prop-types";
const WalletHeader = ({ title }) => <Header>{title}</Header>;

WalletHeader.propTypes = {
  title: PropTypes.string,
};
export default WalletHeader;
